export const viewTitle = "Справочник архивов";
export const viewUniqKey = "archive";
